// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600&family=Poppins:wght@400;500;600;700&family=Roboto&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_heading__8hUcC {
  font-family: "Poppins", sans-serif;
  font-size: 36px;
  font-weight: 700;
  color: #313333;
}

.styles_avatar__-PVJV {
  width: 56px;
  height: 56px;
  border-radius: 100px;
  object-fit: cover;
}

.styles_uploadImageAction__F9pTI {
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #29B473;
  cursor: pointer;
}

.styles_form__p9uPf {
  max-width: 1017px;
}
.styles_formHeading__cTpu\\+ {
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  color: #313333;
  font-size: 20px;
}

.styles_button__6DbWB {
  max-width: 276px;
  height: 44px;
}

.styles_logoutAction__ACkXP {
  color: var(--for-error, #D23535);
  /* For button */
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  /* 150% */
  letter-spacing: -0.32px;
}

@media screen and (max-width: 1440px) {
  .styles_form__p9uPf {
    max-width: 739px;
  }
  .styles_button__6DbWB {
    max-width: 257px;
  }
}
@media screen and (max-width: 1024px) {
  .styles_form__p9uPf {
    max-width: 569px;
  }
  .styles_button__6DbWB {
    max-width: 225px;
  }
}
@media screen and (max-width: 744px) {
  .styles_form__p9uPf {
    max-width: 383px;
  }
  .styles_button__6DbWB {
    max-width: 232px;
  }
}
@media screen and (max-width: 640px) {
  .styles_button__6DbWB {
    max-width: 640px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Settings/Profile/styles.module.scss","webpack://./src/constants/fonts.scss","webpack://./src/constants/colors.scss"],"names":[],"mappings":"AAGA;EACE,kCCFQ;EDGR,eAAA;EACA,gBAAA;EACA,cENM;AFKR;;AAIA;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,iBAAA;AADF;;AAIA;EACE,kCChBQ;EDiBR,gBAAA;EACA,eAAA;EACA,cElBM;EFmBN,eAAA;AADF;;AAIA;EACE,iBAAA;AADF;AAGE;EACE,kCC3BM;ED4BN,gBAAA;EACA,cE9BI;EF+BJ,eAAA;AADJ;;AAKA;EACE,gBAAA;EACA,YAAA;AAFF;;AAKA;EACE,gCAAA;EACA,eAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,SAAA;EACA,uBAAA;AAFF;;AAKA;EACE;IACE,gBAAA;EAFF;EAKA;IACE,gBAAA;EAHF;AACF;AAMA;EACE;IACE,gBAAA;EAJF;EAOA;IACE,gBAAA;EALF;AACF;AAQA;EACE;IACE,gBAAA;EANF;EASA;IACE,gBAAA;EAPF;AACF;AAUA;EACE;IACE,gBAAA;EARF;AACF","sourcesContent":["@import 'constants/fonts.scss';\n@import 'constants/colors.scss';\n\n.heading {\n  font-family: $poppins;\n  font-size: 36px;\n  font-weight: 700;\n  color: $black\n}\n\n.avatar {\n  width: 56px;\n  height: 56px;\n  border-radius: 100px;\n  object-fit: cover;\n}\n\n.uploadImageAction {\n  font-family: $poppins;\n  font-weight: 500;\n  font-size: 14px;\n  color: $green;\n  cursor: pointer;\n}\n\n.form {\n  max-width: 1017px;\n\n  &Heading {\n    font-family: $poppins;\n    font-weight: 600;\n    color: $black;\n    font-size: 20px;\n  }\n}\n\n.button {\n  max-width: 276px;\n  height: 44px;\n}\n\n.logoutAction {\n  color: var(--for-error, #D23535);\n  /* For button */\n  font-family: Poppins;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 24px;\n  /* 150% */\n  letter-spacing: -0.32px;\n}\n\n@media screen and (max-width: 1440px) {\n  .form {\n    max-width: 739px;\n  }\n\n  .button {\n    max-width: 257px;\n  }\n}\n\n@media screen and (max-width: 1024px) {\n  .form {\n    max-width: 569px;\n  }\n\n  .button {\n    max-width: 225px;\n  }\n}\n\n@media screen and (max-width: 744px) {\n  .form {\n    max-width: 383px;\n  }\n\n  .button {\n    max-width: 232px;\n  }\n}\n\n@media screen and (max-width: 640px) {\n  .button {\n    max-width: 640px;\n  }\n}","@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600&family=Poppins:wght@400;500;600;700&family=Roboto&display=swap');\n\n$poppins: 'Poppins', sans-serif;\n$roboto: 'Roboto', sans-serif;\n$inter: 'Inter', sans-serif;\n","$gray: #6C7275;\n$black: #313333;\n$blue: #0084FF;\n$green: #29B473;\n$white: #FEFEFE;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"heading": `styles_heading__8hUcC`,
	"avatar": `styles_avatar__-PVJV`,
	"uploadImageAction": `styles_uploadImageAction__F9pTI`,
	"form": `styles_form__p9uPf`,
	"formHeading": `styles_formHeading__cTpu+`,
	"button": `styles_button__6DbWB`,
	"logoutAction": `styles_logoutAction__ACkXP`
};
export default ___CSS_LOADER_EXPORT___;
